import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Helpers} from "../helpers";

@Component({
    selector: 'accordion',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './accordion.component.html',
    styleUrls: ['./accordion.component.scss']
})
export class AccordionComponent {

    public id: string;

    constructor() {
        this.id = Helpers.uuid();
    }

    @Input() header: string | undefined;
    @Input() disable: boolean = false;
    @Input() toggle: boolean = false;
    @Output() change = new EventEmitter<AccordionComponent>();

    trigger() {
        if (this.disable) return;
        this.toggle = !this.toggle;
        this.change.emit(this);
    }

}
